
/* @flow */
import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import NumericInput from 'react-numeric-input';
import WorkDateRow from './work-date-row';
import WorkDateHelper from './work-date-helper';
import DayPicker, { DateUtils } from 'react-day-picker';
import LocaleUtils from 'react-day-picker/moment';
import moment from 'moment';
/*eslint-disable */
import momentRange from 'moment-range';
/*eslint-enable */
import dateFormat from 'dateformat';
import 'moment/locale/sv';
import 'moment/locale/en-gb';
// import 'react-day-picker/lib/style.css';

const Weekday = ({ weekday, className, localeUtils, locale }) => {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);

  return (
    <div className={className} title={weekdayName}>
      {weekdayName.slice(0, 1)}
    </div>
  );
};

Weekday.propTypes = {
  weekday: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.string,
  localeUtils: PropTypes.object,
  locale: PropTypes.string
};

export class WorkDatePicker extends React.Component {

  static propTypes = {
    workDates: PropTypes.array.isRequired,
    locale: PropTypes.string.isRequired,
    selectedDays: PropTypes.array.isRequired,
    totalWorkHours: PropTypes.string.isRequired,
    removeDays: PropTypes.func.isRequired,
    selectDays: PropTypes.func.isRequired,
    editWorkHours: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.selectDate = this.selectDate.bind(this);
    this.getDateString = this.getDateString.bind(this);
    this.addDates = this.addDates.bind(this);
    this.workHoursChange = this.workHoursChange.bind(this);
    this.selected = this.selected.bind(this);
    this.disabled = this.disabled.bind(this);
    this.handleWeekClicked = this.handleWeekClicked.bind(this);

    let dayPickerLocale;

    switch (this.props.locale) {
      case 'se':
        dayPickerLocale = 'sv';
        break;
      default:
        dayPickerLocale = 'en-gb';
        break;
    }

    this.state = {
      from: null,
      to: null,
      workDates: this.props.workDates,
      workHours: 7.5,
      selectedDays: [],
      currentSelectedDays: {},
      saveButtonStyle: {opacity: 1, pointerEvents: 'auto'},
      dayPickerLocale: dayPickerLocale,
      totalWorkHours: this.props.totalWorkHours
    };
  }

  addRange (range) {
    this.setState({
      currentSelectedDays: {
        startDateString: this.getDateString(range.from),
        startDate: range.from,
        endDate: range.to || range.from
      }
    }, this.addDates);
  }

  addDate (day) {
    const range = DateUtils.addDayToRange(day, this.state);
    this.addRange(range);
  }

  removeDate (day) {
    let formattedDay = moment(day).format('YYYYMMDD');
    this.props.selectedDays.forEach((selectedDay) => {
      if (selectedDay.startDateString === formattedDay) {
        this.props.removeDays([selectedDay]);
      }
    });
  }

  selectDate (day) {
    if (this.selected(day)) {
      return this.removeDate(day);
    }
    this.addDate(day);
  }

  toggleWeek (days) {
    const currentMonth = this.getCurrentMonth();
    const weekdays = days.slice(0, 5).filter(day => day.getMonth() === currentMonth);
    const selected = weekdays.filter(day => this.getDate(day));
    if (selected.length === weekdays.length) {
      return this.removeWeek(weekdays);
    }

    this.addWeek(weekdays);
  }

  getDate (day) {
    return this.props.selectedDays
      .filter((selectedDay) => day.toDateString() === selectedDay.startDate.toDateString())
      .shift();
  };

  getCurrentMonth () {
    // Sorry, showMonth not working
    return this.refs.daypicker.state.currentMonth.getMonth();
  }

  addDates () {
    const days = this.getDates(this.state.currentSelectedDays.startDate, this.state.currentSelectedDays.endDate);
    const selectedDays = [];
    days.forEach((day) => {
      if (this.selected(day)) {
        return;
      }
      this.props.selectDays({
        startDateString: this.getDateString(day),
        startDate: day,
        endDate: day,
        workHours: this.state.workHours,
        displayDate: WorkDateHelper.formatDisplayDate(
          day,
          day
        )
      });
    });
    this.setState({
      selectedDays: this.state.selectedDays.concat(selectedDays)
    });
  }

  getDates (startDate, endDate) {
    // https://gist.github.com/miguelmota/7905510
    const dates = [];
    let currentDate = startDate;
    const addDays = function (days) {
      const date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };

    while (currentDate <= endDate) {
      dates.push(currentDate);
      currentDate = addDays.call(currentDate, 1);
    }

    return dates;
  };

  addWeek (days) {
    let range = DateUtils.addDayToRange(days[0], this.state);
    range = DateUtils.addDayToRange(days[days.length - 1], range);
    this.addRange(range);
  }

  removeWeek (days) {
    const remove = [];
    days.forEach(day => remove.push(this.getDate(day)));
    this.props.removeDays(remove);
  }
  getDateString (date) {
    return dateFormat(date, 'yyyymmdd');
  }
  // Change standard workHours
  workHoursChange (workHours) {
    if (workHours < 0.01) workHours = 0.01;
    if (workHours > 24.00) workHours = 24.00;
    this.setState({
      workHours: workHours
    });
  }
  selected (day) {
    for (let i = 0; i<this.props.selectedDays.length; i++) {
      let startDate = this.props.selectedDays[i].startDate;
      let endDate = moment(this.props.selectedDays[i].endDate).toDate();
      endDate.setHours(12);
      let thisRange = moment.range(startDate, endDate);
      if (thisRange.contains(day)) {
        return true;
      }
    }
  }
  disabled (day) {
    for (let i = 0; i<this.state.selectedDays.length; i++) {
      let startDate = this.state.selectedDays[i].startDate;
      let endDate = moment(this.state.selectedDays[i].endDate).toDate();
      endDate.setHours(12);
      let thisRange = moment.range(startDate, endDate);
      if (thisRange.contains(day)) {
        return true;
      }
    }
    return false;
  }
  handleWeekClicked (week, days) {
    this.toggleWeek(days);
  }
  render () {
    let selected = this.selected;

    return (
      <div>
        <div className='work-date-picker-container'>
          <div className='work-date-picker'>
            <div className='work-date-calendar'>
              <DayPicker
                ref='daypicker'
                numberOfMonths={1}
                modifiers={{selected}}
                onDayClick={this.selectDate}
                localeUtils={LocaleUtils}
                locale={this.state.dayPickerLocale}
                pagedNavigation
                showWeekNumbers
                onWeekClick={this.handleWeekClicked}
                weekdayElement={<Weekday />}
              />
            </div>
            <div className='work-date-details'>
              <p><Translate content='WORKED_HOURS'/></p>
              <NumericInput
                snap
                min={0.01}
                step={0.5}
                max={24}
                precision={2}
                className={'work-date-numeric-stepper'}
                value={this.state.workHours}
                onChange={this.workHoursChange}
              />
            </div>
          </div>
          <div className='day-list-wrapper'>
            <div className='day-list-container'>
              <ul className='day-list'>
                {this.props.selectedDays.map(function (dateObj, i) {
                  return (
                    <WorkDateRow
                      rowData={dateObj}
                      removeDays={this.props.removeDays}
                      editWorkHours={this.props.editWorkHours}
                      key={i}
                      daysIndex={i}
                      day={dateObj}
                    />
                  );
                }, this)}
              </ul>
            </div>
          </div>
        </div>
        <hr />
        <div className='work-date-total-hours-buttons'>
          <p><Translate content='TOTAL_NR_OF_WORKHOURS'/>: {this.props.totalWorkHours}</p>
        </div>
      </div>
    );
  }
}

export default WorkDatePicker;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/work-date/work-date-picker.js
 **/